<template>
  <section>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>
    <PageContent :top-sticked="true">
      <Container :mobile-fluid="true">
        <ul class="list-group">
          <li 
            class="list-group-item"
            v-for="dialog in dialogs"
            :key="dialog.id"
            :class="{ 'is-active': dialog.isDone }"
          >
            <div class="list-group-text">
              <p :class="{ 'text-light': dialog.isDone || (dialog.isLocked && !isPartner) }">
                {{ $domUtils.decode(dialog.title) }}
              </p>
            </div>
            <div class="list-group-control">
              <div class="icon-links">
                <IconLink
                  v-if="!isPartner"
                  :icon-class="['fas', 'fa-edit']"
                  :disabled="dialog.isDone || dialog.isLocked"
                  :locked="dialog.isLocked"
                  :paused="dialog.isInProgress"
                  :checked="dialog.isDone"
                  :to="$wcRouter.path({ name: 'question.show', params: { dialogId: dialog.id } })"
                >回答</IconLink>
                <IconLink
                  :icon-class="['far', 'fa-list-alt']"
                  :disabled="!isPartner && dialog.isNotStarted"
                  :paused="dialog.isInProgress && isPartner"
                  :checked="dialog.isDone && isPartner"
                  :to="$wcRouter.path({ name: 'question.answer', params: { dialogId: dialog.id } })"
                >結果</IconLink>
              </div>
            </div>
          </li>
        </ul>
      </Container>
    </PageContent>

    <Modal
      id="dialog-lock-modal"
      class="is-scrollable"
      title="ロック設定/解除の完了"
      icon="check"
      @ok="$modal.close('dialog-lock-modal')"
    >
      <template #default>
        <p>以下の内容が適用されました。</p>
        <h2 class="headline space-t-2 space-b-2">設定</h2>
        <p v-for="(name, i) in lockedNames" :key="`locked-${i}`" v-html="name"></p>
        <p v-if="lockedNames.length === 0">-</p>
        <h2 class="headline space-t-2 space-b-2">解除</h2>
        <p v-for="(name, i) in unlockedNames" :key="`unlocked-${i}`" v-html="name"></p>
        <p v-if="unlockedNames.length === 0">-</p>
      </template>
    </Modal>
  </section>
</template>

<script>
import IconLink from '@/components/IconLink.js'
import api from '@/api/question'
import Dialog from '@/utils/Dialog'
import { renderError } from '@/utils/error'
import Modal from '@/components/Modal'

export default {
  components: {
    IconLink,
    Modal,
  },

  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'question' }
    }
  },

  data() {
    return {
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    isPartner() {
      return this.$store.getters['auth/isPartner']
    },
    dialogs() {
      return this.$store.state.dialog.items
    },
    lockedNames() {
      return this.dialogs
        .filter(dig => dig.locked)
        .map(dig => dig.title)
    },
    unlockedNames() {
      return this.dialogs
        .filter(dig => !dig.locked)
        .map(dig => dig.title)
    }
  },

  methods: {
    async fetchDialogs() {
      try {
        const response = await api.dialogs(this.businessId)

        let dialogClass = response.map(res => new Dialog({
          id: res.dialog_id,
          title: res.dialog_title,
          questionCount: res.question_count,
          answerCount: res.answer_count,
          locked: res.locked,
          revision: res.revision
        }))

        this.$store.commit('dialog/SET_ITEMS', dialogClass)
      } catch(err) {
        renderError(err)
      }
    }
  },

  created() {
    this.$withLoading(this.fetchDialogs)
  }
}
</script>
